import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Box } from '@mui/material';
import MusicDetailsCardVideo from '../MyMusic/MusicDetailsCardVideo';
import ApiService from '../../services/api-service';
import { isOwnerId } from '../../constants/function';
import Loader from '../../components/Loader';

const VideoPlayerPage = () => {
  const { playListId, videoId } = useParams();
  const history = useHistory();
  const [videos, setVideos] = useState([]);
  const [recordings, setRecordings] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [createdByDetails, setCreatedByDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [playListId]);

  useEffect(() => {
    // If videoId is provided, find and select that video
    if (videoId && (videos.length > 0 || recordings.length > 0)) {
      const allVideos = [...recordings, ...videos];
      const video = allVideos.find(v => v._id === videoId);
      if (video) {
        setSelectedVideo(video);
      }
    }
  }, [videoId, videos, recordings]);

  const fetchData = async () => {
    if (!playListId) return;
    
    setLoading(true);
    try {
      // Fetch playlist details
      const playlistResponse = await ApiService.PLAYLIST_DETAIL({
        _id: playListId,
        pageNo: 1,
        pageSize: 100
      });
      
      if (playlistResponse?.result) {
        setCreatedByDetails(playlistResponse.result.createdByDetails);
      }

      // Fetch videos
      const videoResponse = await ApiService.VIDEO_USER(playListId);
      if (videoResponse?.result?.length > 0) {
        const formattedVideos = videoResponse.result.map((item) => ({
          _id: item._id,
          title: item.title,
          thumbnailUrl: item.thumbnail?.url,
          thumbnailImg: item.thumbnail?.url,
          duration: item.duration,
          views: item.views || 0,
          createdAt: item.createdAt,
          url: item.video?.url,
          type: 'video',
          uploader: item.uploader,
          studioId: item.studioId,
          private: item.private || false
        }));
        setVideos(formattedVideos);
      }

      // Fetch recordings
      const recordingResponse = await ApiService.RECORDINGS(`studioId=${playListId}&pageNo=1&pageSize=50`);
      if (recordingResponse.result?.length > 0) {
        const formattedRecordings = recordingResponse.result.map((item) => ({
          _id: item._id,
          title: item.title || `Live Recording`,
          thumbnailUrl: item.thumbnailImg,
          thumbnailImg: item.thumbnailImg,
          duration: item.duration,
          views: item.views || 0,
          createdAt: item.createdAt,
          url: item.url,
          type: 'recording',
          uploader: item.uploader || item.createdBy,
          studioId: item.studioId,
          private: item.private || false
        }));
        setRecordings(formattedRecordings);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleVideoSelection = (video) => {
    setSelectedVideo(video);
    // Update URL with the selected video ID
    history.push(`/app/video-player/${playListId}/${video._id}`);
  };

  const handleVideoUpdate = (updatedVideo) => {
    // Update the video in both videos and recordings arrays
    setVideos(prevVideos => 
      prevVideos.map(v => v._id === updatedVideo._id ? { ...v, ...updatedVideo } : v)
    );
    setRecordings(prevRecordings => 
      prevRecordings.map(r => r._id === updatedVideo._id ? { ...r, ...updatedVideo } : r)
    );
    // Update selected video if it's the one being updated
    if (selectedVideo?._id === updatedVideo._id) {
      setSelectedVideo(prev => ({ ...prev, ...updatedVideo }));
    }
  };

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: 'var(--background-color, #0a0a0a)'
      }}>
        <Loader />
      </Box>
    );
  }

  return (
    <Box sx={{ 
      position: 'relative', 
      minHeight: '100vh',
      backgroundColor: 'var(--background-color, #0a0a0a)',
      overflow: 'auto'
    }}>
      <MusicDetailsCardVideo
        playListId={playListId}
        selectedVideo={selectedVideo}
        onVideoSelect={handleVideoSelection}
        onVideoUpdate={handleVideoUpdate}
        videos={videos}
        recordings={recordings}
        isOwner={(() => {
          // Check if user is either the playlist creator OR the video uploader
          const playlistOwnerId = createdByDetails?._id || createdByDetails?.createdBy;
          const isPlaylistOwner = isOwnerId(playlistOwnerId);
          const isVideoUploader = selectedVideo && isOwnerId(selectedVideo.uploader);
          const isOwner = isPlaylistOwner || isVideoUploader;
          
          console.log('VideoPlayerPage - createdByDetails:', createdByDetails);
          console.log('VideoPlayerPage - playlistOwnerId:', playlistOwnerId);
          console.log('VideoPlayerPage - isPlaylistOwner:', isPlaylistOwner);
          console.log('VideoPlayerPage - isVideoUploader:', isVideoUploader);
          console.log('VideoPlayerPage - selectedVideo uploader:', selectedVideo?.uploader);
          console.log('VideoPlayerPage - final isOwner:', isOwner);
          
          return isOwner;
        })()}
        createdByDetails={createdByDetails}
      />
    </Box>
  );
};

export default VideoPlayerPage;